/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import { Modal, Range, Slider, WhiteSpace } from "antd-mobile";
import { MdRestaurant } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import * as stallSelectors from "../../../selectors/stall";
import * as filterSelectors from "../../../selectors/filter";
import * as tagSelectors from "../../../selectors/tag";
import Theme from "../../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const StyledHeaderContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledTitle = styled.span`
  margin-left: 8px;
  color: black;
  font-weight: bold;
  font-size: 0.8em;
`;

const StyledCloseButton = styled.span`
  cursor: pointer;
  color: ${Theme.PrimaryColor};
  font-size: 0.7em;
  &:hover {
    opacity: 0.5;
    text-decoration: underline;
  }
`;

const StyledBreakline = styled.hr`
  color: lightgray;
  background-color: lightgray;
  width: 100%;
  height: -0.5px;
`;

const StyledContentContainer = styled(StyledContainer)`
  height: auto;
  align-self: stretch;
  padding: 0px;
  overflow-y: scroll;
`;

const StyledSectionTitle = styled.span`
  font-weight: bold;
  align-self: flex-start;
  font-size: 0.8em;
  color: gray;
`;

const StyledPrice = styled.span`
  align-self: flex-start;
  font-size: 0.8em;
  color: ${Theme.PrimaryColor};
`;

const StyledEta = styled.span`
  align-self: flex-start;
  font-size: 0.8em;
  color: ${Theme.PrimaryColor};
`;

const StyledGirdContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
`;

const StyledCategoryItemContainer = styled.div`
  cursor: pointer;
  max-width: 20%;
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  margin-bottom: 0.8em;
`;

const StyledCategoryButton = styled.div`
  padding: 5px;
  width: 90%;
  font-size: 0.7em;
  border-radius: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => (props.selected ? "white" : "black")};
  background: ${props => (props.selected ? Theme.PrimaryColor : "white")};
  border: ${props =>
    props.selected
      ? "0.5px solid " + Theme.PrimaryColor
      : "0.5px solid lightgrey"};
`;

class FilterModal extends Component {
  constructor(props) {
    super(props);
    const { filterData, selectedFilterData } = this.props;
    const filterState = this.setFilterData(filterData, selectedFilterData);

    this.state = {
      ...filterState
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { selectedFilterData, filterData } = nextProps;
    const filterState = this.setFilterData(filterData, selectedFilterData);

    if (
      this.props.selectedFilterData !== nextProps.selectedFilterData ||
      this.props.filterData !== nextProps.filterData
    ) {
      this.setState({
        ...filterState
      });
    }
  }

  setFilterData = (filterData, selectedFilterData) => {
    const priceRangeMin = stallSelectors.getStallItemFilterPriceRangeMin(
      filterData
    );
    const priceRangeMax = stallSelectors.getStallItemFilterPriceRangeMax(
      filterData
    );
    const etaMax = stallSelectors.getStallItemFilterEtaMinuteMax(filterData);
    const nextPropsPriceRangeMin = filterSelectors.getFilterDataMinPrice(
      selectedFilterData
    );
    const nextPropsPriceRangeMax = filterSelectors.getFilterDataMaxPrice(
      selectedFilterData
    );
    const nextPropsEtaMax = filterSelectors.getFilterDataEtaTime(
      selectedFilterData
    );
    const nextPropsFoodTag = filterSelectors.getFilterDataFoodTag(
      selectedFilterData
    );

    return {
      minPrice: nextPropsPriceRangeMin || priceRangeMin,
      maxPrice: nextPropsPriceRangeMax || priceRangeMax,
      etaTimeValue: nextPropsEtaMax || etaMax,
      selectedFood: nextPropsFoodTag || []
    };
  };

  onCategoryItemClicked = item => {
    const { selectedFood } = this.state;

    let newSelectedFood = selectedFood;
    let selectedData = selectedFood.find(foodTag => foodTag.id === item.id);
    if (selectedData === undefined) {
      newSelectedFood = newSelectedFood.concat(item);
    } else {
      newSelectedFood = newSelectedFood.filter(
        foodTag => foodTag.id !== item.id
      );
    }
    this.setState({
      selectedFood: newSelectedFood
    });
  };

  onPriceRangeChanged = range => {
    this.setState({
      minPrice: range[0],
      maxPrice: range[1]
    });
  };

  onETAValueChange = values => {
    this.setState({
      etaTimeValue: values
    });
  };

  onClose = () => {
    const { onClose } = this.props;
    const { etaTimeValue, minPrice, maxPrice, selectedFood } = this.state;
    const { filterData } = this.props;
    const priceRangeMin = stallSelectors.getStallItemFilterPriceRangeMin(
      filterData
    );
    const priceRangeMax = stallSelectors.getStallItemFilterPriceRangeMax(
      filterData
    );
    const etaMax = stallSelectors.getStallItemFilterEtaMinuteMax(filterData);
    const etaValue = etaTimeValue === etaMax ? null : etaTimeValue;
    const formattedMinPrice = minPrice === priceRangeMin ? null : minPrice;
    const formattedMaxPrice = maxPrice === priceRangeMax ? null : maxPrice;
    const filterResult = {
      price: {
        minPrice: formattedMinPrice,
        maxPrice: formattedMaxPrice
      },

      eta: {
        maxMinutes: {
          etaValue
        }
      },

      foodTag: selectedFood
    };

    onClose && onClose(filterResult);
  };

  render() {
    const { selectedFood, minPrice, maxPrice, etaTimeValue } = this.state;
    const { shouldShow, onClose, onTouchStart, filterData } = this.props;
    const priceRangeMin = stallSelectors.getStallItemFilterPriceRangeMin(
      filterData
    );
    const priceRangeMax = stallSelectors.getStallItemFilterPriceRangeMax(
      filterData
    );
    const priceRangeStep = stallSelectors.getStallItemFilterPriceStep(
      filterData
    );
    const etaTime = stallSelectors.getStallItemFilterEtaMinuteMax(filterData);
    const foodTag = stallSelectors.getStallItemFilterTagItems(filterData);

    return (
      <Modal
        className={"filter-modal"}
        visible={shouldShow}
        transparent
        maskClosable={false}
        onClose={() => this.onClose()}
        wrapProps={{ onTouchStart: onTouchStart }}
      >
        <StyledContainer>
          {/* Header Section */}
          <StyledHeaderContainer>
            <StyledTitleContainer>
              <MdRestaurant color={Theme.PrimaryColor} size={"1.3em"} />
              <StyledTitle>
                <FormattedMessage
                  id="modal.filter.title"
                  defaultMessage="Make up your mind"
                  description="Modal Filter Title"
                />
              </StyledTitle>
            </StyledTitleContainer>
            <StyledCloseButton
              className={"underline_btn"}
              onClick={() => this.onClose()}
            >
              <FormattedMessage
                id="app.done"
                defaultMessage="Done"
                description="Close Button Title"
              />
            </StyledCloseButton>
          </StyledHeaderContainer>
          <WhiteSpace size={"xs"} />
          <StyledBreakline />
          <StyledContentContainer>
            <WhiteSpace size={"md"} />
            {/* Price Filter Section */}
            <StyledSectionTitle>
              <FormattedMessage
                id="modal.filter.price.title"
                defaultMessage="Price Range"
                description="Price Range Title"
              />
            </StyledSectionTitle>
            <WhiteSpace size={"sm"} />
            <StyledPrice>
              RM {minPrice} ~ RM {maxPrice}
            </StyledPrice>
            <WhiteSpace size={"lg"} />
            {priceRangeMax === priceRangeMin ? (
              false
            ) : (
              <Range
                style={{ width: "90%", height: "auto", marginLeft: "3px" }}
                min={priceRangeMin}
                max={priceRangeMax}
                step={priceRangeStep}
                allowCross={false}
                defaultValue={[minPrice, maxPrice]}
                trackStyle={[{ backgroundColor: Theme.PrimaryColor }]}
                handleStyle={[
                  {
                    backgroundColor: Theme.PrimaryColor,
                    border: "unset",
                    width: "1em",
                    height: "1em",
                    marginTop: "-0.45em"
                  },
                  {
                    backgroundColor: Theme.PrimaryColor,
                    border: "unset",
                    width: "1em",
                    height: "1em",
                    marginTop: "-0.45em"
                  }
                ]}
                railStyle={{
                  backgroundColor: "grey",
                  height: "2px"
                }}
                onChange={range => this.onPriceRangeChanged(range)}
              />
            )}
            {/* Time Filter Section */}
            <WhiteSpace size={"lg"} />
            <StyledSectionTitle>
              <FormattedMessage
                id="modal.filter.eta.title"
                defaultMessage="Estimate Time of Arrival (ETA)"
                description="ETA Title"
              />
            </StyledSectionTitle>
            <WhiteSpace size={"sm"} />
            <StyledEta>
              <FormattedMessage
                id="modal.filter.eta.description"
                defaultMessage="5 mins to wait"
                description="eta description"
                values={{
                  etaValue: etaTimeValue
                }}
              />
            </StyledEta>
            <WhiteSpace size={"lg"} />
            <Slider
              style={{ width: "90%", height: "auto", marginLeft: "3px" }}
              min={0}
              max={etaTime}
              step={5}
              defaultValue={etaTimeValue}
              trackStyle={{ backgroundColor: Theme.PrimaryColor }}
              handleStyle={{
                backgroundColor: Theme.PrimaryColor,
                border: "unset",
                width: "1em",
                height: "1em",
                marginTop: "-0.45em"
              }}
              railStyle={{
                backgroundColor: "grey",
                height: "2px"
              }}
              onChange={value => this.onETAValueChange(value)}
            />
            <WhiteSpace size={"md"} />
            <StyledBreakline />
            <WhiteSpace size={"lg"} />
            {/* Category Filter Section */}
            <StyledGirdContainer>
              {foodTag.map((item, index) => {
                const id = tagSelectors.getFoodTagID(item);
                const image = tagSelectors.getFoodTagLargeImageSrc(item);
                const name = tagSelectors.getFoodTagName(item);
                const isActive = selectedFood.find(tag => {
                  if (tag.id === id) {
                    return true;
                  }
                });

                return (
                  <StyledCategoryItemContainer
                    key={index}
                    onClick={() => this.onCategoryItemClicked(item)}
                  >
                    <img
                      ref={ref => (this.itemImage = ref)}
                      src={
                        image ? image : "https://via.placeholder.com/100x100"
                      }
                      alt={"stall-filter-" + id + "-" + name}
                      style={{
                        width: "65%",
                        padding: "5px"
                      }}
                      onLoad={() => {
                        window.dispatchEvent(new Event("resize"));
                      }}
                    />
                    <WhiteSpace size={"sm"} />
                    <StyledCategoryButton selected={isActive}>
                      {name}
                    </StyledCategoryButton>
                  </StyledCategoryItemContainer>
                );
              })}
            </StyledGirdContainer>
          </StyledContentContainer>
        </StyledContainer>
      </Modal>
    );
  }
}

FilterModal.propTypes = {
  shouldShow: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onTouchStart: PropTypes.func.isRequired,
  filterData: PropTypes.object,
  selectedFilterData: PropTypes.object
};

FilterModal.defaultProps = {
  shouldShow: false
};

export default FilterModal;



// WEBPACK FOOTER //
// ./src/containers/StallPage/FilterModal/index.js